export default __webpack_public_path__ + "static/media/pie_3.469d79f2.svg";